import { render, staticRenderFns } from "./FullReductionPop.vue?vue&type=template&id=ac62ff42&scoped=true&"
import script from "./FullReductionPop.vue?vue&type=script&lang=js&"
export * from "./FullReductionPop.vue?vue&type=script&lang=js&"
import style0 from "./FullReductionPop.vue?vue&type=style&index=0&id=ac62ff42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac62ff42",
  null
  
)

export default component.exports